const validateEmail = (email) => {
  const MAX_EMAIL_LENGTH = 253;

  if (!email || typeof email !== 'string' || email.length > MAX_EMAIL_LENGTH) return false;

  // eslint-disable-next-line no-useless-escape
  const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return regexp.test(email);
};

export default {
  validateEmail,
};
